import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const api = axios.create({ baseURL: API_URL });

function getToken() {
  return localStorage.getItem('token') || sessionStorage.getItem('token') || null;
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const token = getToken();
      if (!token && window.location.pathname !== '/login') {
        localStorage.removeItem('token'); localStorage.removeItem('user');
        sessionStorage.removeItem('token'); sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export const imgUrl = (p) => !p ? null : p.startsWith('http') ? p : `/uploads/${p}`;
